import LoanContracts from "../LoanContracts";

export const useMyContracts = () => {
    const tabs = [
        {
            key: "loan",
            label: "Empréstimos",
            component: <LoanContracts />,
        },
        {
            key: "card",
            label: "Cartões",
            component: <p>Página em manutenção</p>,
        },
        {
            key: "withdraw",
            label: "Saque",
            component: <p>Página em manutenção</p>,
        },
    ];

    return {
        tabs
    }
}